import React, { Component } from 'react';
import axios from 'axios';

class Page extends Component {
  render() {
    return (
      <div>
        <h1>{this.state.slug}</h1>
        <h1>{console.log(this.state.page && this.state.page.title)}</h1>
      </div>
    );
  }

  constructor(props) {
    console.log(props);
    super();
    this.state = {
      slug: null,
      page: null,
    };
  }

  componentDidMount() {
    this.getPage();
  }
  componentWillReceiveProps(nextProps) {
    var slug = nextProps.match.params.slug;
    if (slug !== this.props.match.params.slug) {
      this.getPage(slug);
    }
  }

  getPage(slug) {
    slug = slug || this.props.match.params.slug;
    console.log('getPage');
    console.log(this);
    this.setState({ slug });
    axios
      .get('/page/' + slug)
      .then(result => {
        console.log(result);
        this.setState({ page: result.data });
      })
      .catch(error => {
        console.log(error);
      });
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.jsx